// for add employee

export const RESET_CHANGE_USER_PASSWORD = "reset_CHANGE_USER_PASSWORD";
export const CHANGE_USER_PASSWORD = "CHANGE_USER_PASSWORD";
export const CHANGE_USER_PASSWORD_SUCCESS = "CHANGE_USER_PASSWORD_success";
export const CHANGE_USER_PASSWORD_FAILURE = "CHANGE_USER_PASSWORD_failure";
